import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { fmtDate, fmtTotals, sumByCurrency, statusMeta } from "@/lib/format";
import { ArrowLeft, Car, Phone, EnvelopeSimple } from "@phosphor-icons/react";

export default function ClientDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    api.get(`/clients/${id}`).then((r) => setC(r.data));
    api.get(`/clients/${id}/history`).then((r) => setHistory(r.data));
  }, [id]);

  if (!c) return <div className="text-muted-foreground">Завантаження...</div>;

  return (
    <div className="max-w-4xl">
      <button onClick={() => navigate("/clients")} className="flex items-center gap-1 text-sm text-muted-foreground mb-3 hover:text-foreground" data-testid="back-btn">
        <ArrowLeft size={16} /> До клієнтів
      </button>
      <PageHeader title={c.name} />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-5">
        <Card className="p-5 text-sm space-y-2">
          <div className="flex items-center gap-2"><Phone size={16} className="text-muted-foreground" /> {c.phone || "—"}</div>
          <div className="flex items-center gap-2"><EnvelopeSimple size={16} className="text-muted-foreground" /> {c.email || "—"}</div>
          {c.notes && <div className="text-muted-foreground pt-2">{c.notes}</div>}
        </Card>
        <Card className="p-5 md:col-span-2">
          <h3 className="font-head font-bold mb-3 flex items-center gap-2"><Car size={20} /> Автомобілі</h3>
          <div className="space-y-2">
            {(c.vehicles || []).map((v) => (
              <div key={v.id} className="flex items-center justify-between text-sm py-2 border-b border-border last:border-0">
                <div><span className="font-semibold">{v.make} {v.model}</span> <span className="text-muted-foreground">{v.year}</span></div>
                <div className="text-muted-foreground">{v.plate} · {v.mileage || "—"} км</div>
              </div>
            ))}
            {(c.vehicles || []).length === 0 && <div className="text-sm text-muted-foreground">Немає авто</div>}
          </div>
        </Card>
      </div>

      <Card className="p-6">
        <h3 className="font-head font-bold mb-3">Історія обслуговування</h3>
        <div className="space-y-2">
          {history.map((o) => {
            const st = statusMeta(o.status);
            return (
              <button key={o.id} onClick={() => navigate(`/orders/${o.id}`)} data-testid={`history-order-${o.number}`}
                className="w-full flex items-center justify-between text-sm py-2.5 border-b border-border last:border-0 hover:bg-accent/40 px-2 -mx-2 rounded transition-colors">
                <div className="text-left"><span className="font-semibold">{o.number}</span> <span className="text-muted-foreground ml-2">{fmtDate(o.created_at)}</span></div>
                <div className="flex items-center gap-3">
                  <span className="text-xs px-2 py-0.5 rounded" style={{ background: st.color + "22", color: st.color }}>{st.label}</span>
                  <span className="font-semibold">{fmtTotals(o.totals_by_currency || sumByCurrency([...(o.services || []), ...(o.parts || [])]))}</span>
                </div>
              </button>
            );
          })}
          {history.length === 0 && <div className="text-sm text-muted-foreground">Історія порожня</div>}
        </div>
      </Card>
    </div>
  );
}
